import { useEffect, useState, RefObject } from "react";

export default function useScrollStatus(containerRef: RefObject<HTMLElement>) {
  const [scrollableStatus, setScrollStatus] = useState({ x: false, y: false });

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const updateScrollState = () => {
      const {
        scrollWidth,
        scrollHeight,
        clientWidth,
        clientHeight,
        scrollLeft,
        scrollTop,
      } = container;

      const canScrollX = scrollWidth > clientWidth;
      const isAtRightEdge = scrollLeft >= scrollWidth - clientWidth - 1;
      const canScrollY = scrollHeight > clientHeight;
      const isAtBottomEdge = scrollTop >= scrollHeight - clientHeight - 1;

      setScrollStatus({
        x: canScrollX && !isAtRightEdge,
        y: canScrollY && !isAtBottomEdge,
      });
    };

    // Initial check after table renders
    updateScrollState();

    // Basic scroll listener for fade effects
    const onScroll = updateScrollState;
    container.addEventListener("scroll", onScroll);

    return () => {
      container.removeEventListener("scroll", onScroll);
    };
  }, [containerRef]);

  return scrollableStatus;
}
